<template>
    <b-badge
        v-b-tooltip="tooltipConfig"
        :variant="variant"
        class="participant-status"
        :tabindex="hasComment ? 0 : null"
        :aria-label="ariaLabel"
    >
        <span>{{ text }}</span>
        <i
            v-if="hasComment"
            class="fas fa-comment-alt participant-status__comment-icon"
            aria-hidden="true"
        ></i>
    </b-badge>
</template>

<script>
const TOOLTIP_COMMENT_LIMIT = 500;
const FULL_TEXT_HINT = 'Полный текст — в жизненном цикле заявки.';

export default {
    name: 'ParticipantStatusBadge',
    props: {
        text: {
            type: String,
            required: true
        },
        variant: {
            type: String,
            default: 'secondary'
        },
        decision: {
            type: Object,
            default: null
        }
    },
    computed: {
        comment() {
            return this.decision && this.decision.comment
                ? String(this.decision.comment).trim()
                : '';
        },
        hasComment() {
            return Boolean(this.comment);
        },
        tooltipComment() {
            if (this.comment.length <= TOOLTIP_COMMENT_LIMIT) return this.comment;
            return `${this.comment.slice(0, TOOLTIP_COMMENT_LIMIT).trimEnd()}…\n${FULL_TEXT_HINT}`;
        },
        tooltipText() {
            if (!this.hasComment) return '';
            const adminNote = this.decision.admin_override
                ? '<div class="participant-decision-tooltip__admin">Действие выполнил администратор.</div>'
                : '';
            return [
                '<div class="participant-decision-tooltip__content">',
                `<blockquote>${this.escapeHtml(this.tooltipComment)}</blockquote>`,
                `<div class="participant-decision-tooltip__footer">— ${this.escapeHtml(this.authorName)}</div>`,
                adminNote,
                '</div>'
            ].join('');
        },
        tooltipConfig() {
            return {
                title: this.tooltipText,
                html: true,
                triggers: 'hover focus click',
                boundary: 'viewport',
                customClass: 'participant-decision-tooltip'
            };
        },
        ariaLabel() {
            if (!this.hasComment) return null;
            return `${this.text}. ${this.decision.comment_label || 'Комментарий'}: ${this.tooltipComment}. Автор: ${this.authorName}`;
        },
        authorName() {
            const author = this.decision && this.decision.author ? this.decision.author : null;
            if (!author) return 'Автор не найден';
            return [
                author.last_name || author.lastName || '',
                author.first_name || author.firstName || ''
            ].join(' ').trim() || 'Автор не найден';
        }
    },
    methods: {
        escapeHtml(value) {
            return String(value === undefined || value === null ? '' : value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }
    }
};
</script>

<style scoped>
.participant-status__comment-icon {
    margin-left: 0.35rem;
    font-size: 0.72em;
}
</style>

<style>
.participant-decision-tooltip .tooltip-inner {
    max-width: min(30rem, calc(100vw - 2rem));
    padding: 0.55rem 0.7rem;
    text-align: left;
    overflow-wrap: anywhere;
}

.participant-decision-tooltip__content blockquote {
    border-left: 3px solid rgba(255, 255, 255, 0.65);
    font-style: italic;
    margin: 0;
    padding: 2px 0 2px 8px;
    white-space: pre-wrap;
}

.participant-decision-tooltip__footer {
    font-size: 12px;
    font-weight: 700;
    margin-top: 6px;
}

.participant-decision-tooltip__admin {
    font-size: 11px;
    margin-top: 4px;
    opacity: 0.8;
}
</style>
